module.exports = __webpack_public_path__ + "static/img/mncs@2x.c900231b.png";